import React, { useEffect, useState, useRef } from "react";
import { Container } from "./styled";
import { useLocation } from "react-router-dom";

const StandingTable = ({
  appData,
  games,
  league,
  zone,
  activeSeason,
  activeTeam,
}) => {
  const [teams, setTeams] = useState([]);
  const [teamsSur, setTeamsSur] = useState([]);
  const [teamsNorte, setTeamsNorte] = useState([]);
  const [viewFormat, setViewFormat] = useState("all");
  const activeRowRef = useRef(null);

  useEffect(() => {
    if (league !== null) {
      let teamsArr = [];
      let teamsSurArr = [];
      let teamsNorteArr = [];
      appData.teams?.forEach((team) => {
        // Verificar si el equipo ha estado en la misma liga en temporadas anteriores o en la actual
        const hasPlayedInSameLeague = team.history?.some(
          (entry) => entry.season === activeSeason && entry.league === league
        );

        if (hasPlayedInSameLeague) {
          teamsArr.push({
            _id: team._id,
            name: team.name,
            gamesWon: 0,
            gamesLost: 0,
            totalPoints: 0,
            pointsMade: 0,
            pointsRecibed: 0,
            zone: team.zone === "sur" ? "sur" : "norte",
          });
        }
      });
      for (let index = 0; index < games?.length; index++) {
        if (
          games[index].category === league &&
          games[index].season === activeSeason &&
          games[index].stage === "Fase regular"
        ) {
          let localTotalPts = 0;
          let visitTotalPts = 0;
          const localTeam = teamsArr?.find(
            (object) => object._id === games[index].local_team
          );
          games[index].local_stats.forEach((element) => {
            localTotalPts += element.pts;
          });
          const visitTeam = teamsArr?.find(
            (object) => object._id === games[index].visit_team
          );
          games[index].visit_stats.forEach((element) => {
            visitTotalPts += element.pts;
          });

          localTeam.pointsMade += localTotalPts;
          localTeam.pointsRecibed += visitTotalPts;
          visitTeam.pointsMade += visitTotalPts;
          visitTeam.pointsRecibed += localTotalPts;
          if (localTotalPts > visitTotalPts) {
            localTeam.gamesWon++;
            visitTeam.gamesLost++;
          } else {
            localTeam.gamesLost++;
            visitTeam.gamesWon++;
          }
        }
      }
      teamsArr.forEach((element) => {
        element.totalPoints = element.gamesWon * 2 + element.gamesLost;
      });
      teamsArr.sort(function (a, b) {
        return (
          b.totalPoints - a.totalPoints ||
          b.gamesWon - a.gamesWon ||
          a.gamesLost - b.gamesLost ||
          b.pointsMade - a.pointsMade ||
          a.pointsRecibed - b.pointsRecibed
        );
      });

      setViewFormat("all");
      setTeamsSur(teamsSurArr);
      setTeamsNorte(teamsNorteArr);
      setTeams(teamsArr);
    }
  }, [appData, league, activeSeason, games]);

  // Desplazar hacia la fila activa al cargar la página
  useEffect(() => {
    if (activeRowRef.current) {
      activeRowRef.current.scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
    }
  }, [teams, teamsNorte, teamsSur]);

  const handleTableView = () => {
    let popup = document.getElementsByClassName(
      "standing-chart-header-options-popup"
    )[0];
    if (popup.classList.contains("active")) popup.classList.remove("active");
    else popup.classList.add("active");
  };

  return (
    <Container>
      {league === "LNB" ? (
        <>
          <div className="standing-chart-header flex_center_space-between">
            <p className="title">LNB Posiciones</p>
            <div className="standing-chart-header-options">
              <p>
                Vista <span>LNB</span>
              </p>
              <div className="standing-chart-header-options-popup">
                <p>Todos</p>
                <p>Sur</p>
                <p>Norte</p>
              </div>
            </div>
          </div>
          <div className="table-container">
            <table>
              <thead>
                <tr>
                  <th scope="col">Pos.</th>
                  <th scope="col">Equipo</th>
                  <th scope="col">PJ</th>
                  <th scope="col">PG</th>
                  <th scope="col">PP</th>
                  <th scope="col">PF</th>
                  <th scope="col">PC</th>
                  <th scope="col">PD</th>
                  <th scope="col">PTS</th>
                </tr>
              </thead>
              <tbody>
                {teams.map((team, i) => (
                  <tr
                    className={`position-${i} ${
                      team._id === activeTeam ? "activeRow" : null
                    }`}
                    ref={team._id === activeTeam ? activeRowRef : null}
                  >
                    <td>{i + 1}</td>
                    <td>{team.name}</td>
                    <td>{team.gamesWon + team.gamesLost}</td>
                    <td>{team.gamesWon}</td>
                    <td>{team.gamesLost}</td>
                    <td>{team.pointsMade}</td>
                    <td>{team.pointsRecibed}</td>
                    <td>{team.pointsMade - team.pointsRecibed}</td>
                    <td>{team.totalPoints}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </>
      ) : (
        <>
          <div className="standing-chart-header flex_center_space-between">
            <p className="title">LA Posiciones</p>
            <div className="standing-chart-header-options">
              <p>
                Vista{" "}
                <span id="span-LA" onClick={handleTableView}>
                  LA
                </span>
              </p>
              <div className="standing-chart-header-options-popup">
                <p
                  onClick={(e) => {
                    setViewFormat("all");
                    handleTableView();
                  }}
                >
                  Todos
                </p>
                <p
                  onClick={(e) => {
                    setViewFormat("sur");
                    handleTableView();
                  }}
                >
                  Sur
                </p>
                <p
                  onClick={(e) => {
                    setViewFormat("norte");
                    handleTableView();
                  }}
                >
                  Norte
                </p>
              </div>
            </div>
          </div>
          <div className="table-container">
            <table>
              <thead>
                <tr>
                  <th scope="col">Pos.</th>
                  <th scope="col">Equipo</th>
                  <th scope="col">PJ</th>
                  <th scope="col">PG</th>
                  <th scope="col">PP</th>
                  <th scope="col">PF</th>
                  <th scope="col">PC</th>
                  <th scope="col">PD</th>
                  <th scope="col">PTS</th>
                </tr>
              </thead>
              <tbody>
                {teams
                  .filter((e) => viewFormat === "all" || e.zone === viewFormat)
                  .map((team, i) => (
                    <tr
                      className={`position-${i} ${
                        team._id === activeTeam ? "activeRow" : null
                      }`}
                      ref={team._id === activeTeam ? activeRowRef : null}
                    >
                      <td>{i + 1}</td>
                      <td>{team.name}</td>
                      <td>{team.gamesWon + team.gamesLost}</td>
                      <td>{team.gamesWon}</td>
                      <td>{team.gamesLost}</td>
                      <td>{team.pointsMade}</td>
                      <td>{team.pointsRecibed}</td>
                      <td>{team.pointsMade - team.pointsRecibed}</td>
                      <td>{team.totalPoints}</td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
        </>
      )}
    </Container>
  );
};

export default StandingTable;
